module.exports = "/packs/images/social_enerprise_logo_black~1dbe1ddc0b0864542f6f3bbe1c1239d3.png";